import Botao from 'componentes/Botao';
import style from './FrontCard.module.scss';


export default function FrontCard({ clique, foto, nome, raca }) {  
  
  return (
    
      <div className={style.post}>
        <div className={style.titulo}>
          <h2>Nome: {nome}</h2>
          <h3>Raça: {raca}</h3>
        </div>
        <img
          className={style.fotoCard}
          src={foto}
          alt={`Imagem do animal ${nome}`}
        />

        <div className={style.botao}>
          <Botao tipo="button" cliqueBotao={clique}>Ver mais</Botao>
        </div>        
      </div>
    

  )
}